import { Directive, HostListener, EventEmitter, Output, ElementRef } from '@angular/core'

@Directive({
  selector: '[linScrollable]',
  standalone: false,
})
export class ScrollableDirective {
  @Output() scrollPosition = new EventEmitter<boolean>()

  constructor(public el: ElementRef) {}

  @HostListener('scroll', ['$event'])
  onScroll(event): void {
    const top: number = event.target.scrollTop
    const height: number = this.el.nativeElement.scrollHeight
    const offset: number = this.el.nativeElement.offsetHeight

    if (top > height - offset - 1) {
      this.scrollPosition.emit(true)
    }
  }
}
